module.exports = __webpack_public_path__ + "static/img/Ocon.799dd7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ocon.jpg
// module id = +qA/
// module chunks = 1